import { render } from "./JoinUsPage.vue?vue&type=template&id=5570097d&scoped=true"
import script from "./JoinUsPage.vue?vue&type=script&lang=js"
export * from "./JoinUsPage.vue?vue&type=script&lang=js"

import "./JoinUsPage.vue?vue&type=style&index=0&id=5570097d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5570097d"]])

export default __exports__